import React, { useState } from "react";
import PageHeading from "../components/PageHeading";
import AgencyChoice from "../components/AgencyChoice";
import axios from "../axios/AxiosInstance";
import { apiErrorMessage } from "../utils/apiError";
import { rememberAgency } from "../services/agencyPreference";
import { message } from "antd";

export default function SwitcherAgencePage() {
  const [busy, setBusy] = useState(null);
  const choose = async agency => {
    if (busy) return;
    setBusy(agency.id);
    try {
      await axios.post("agency/switch", { agency: agency.id });
      rememberAgency(agency.id, agency.name, agency.city);
      window.location.assign("/dashboard");
    } catch (error) {
      message.error(apiErrorMessage(error, error.response?.status === 403 || error.response?.data?.statusCode === 403 ? "Vous n’êtes pas autorisé à accéder à cette agence." : "Impossible de changer d’agence. Réessayez."));
      setBusy(null);
    }
  };
  return <main className="min-h-screen bg-slate-50 p-6 sm:p-10">
    <div className="mx-auto max-w-2xl">
      <PageHeading icon="clients" title="Choisir une agence" description="Retrouvez les clients, les candidats et les missions de votre agence." />
      <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
        <AgencyChoice currentCity={localStorage.getItem("agencyCity") || ""} busy={busy} onChoose={choose} />
      </section>
    </div>
  </main>;
}
